var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsAppShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 30.0001C24.2314 29.9988 29.7119 25.8791 31.4448 19.8935C33.1778 13.9079 30.746 7.49747 25.4792 4.16719C20.2124 0.836907 13.3784 1.38856 8.71391 5.52052C4.04943 9.65248 2.6774 16.37 5.348 22.0001L2 30.0001L10.784 28.0001C12.9618 29.3127 15.4572 30.0044 18 30.0001Z",
    stroke: "#F2F2F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0822 14.1322C12.9436 14.1222 12.0276 13.1929 12.0342 12.0543C12.0408 10.9156 12.9675 9.99697 14.1061 10.0003C15.2448 10.0035 16.1661 10.9275 16.1662 12.0662C16.1607 13.2119 15.2279 14.1366 14.0822 14.1322V14.1322Z",
    stroke: "#F2F2F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.834 19.836C19.8276 20.6794 20.3305 21.4433 21.1077 21.7707C21.8849 22.0981 22.7829 21.9244 23.3818 21.3306C23.9807 20.7368 24.1623 19.8404 23.8416 19.0604C23.521 18.2804 22.7614 17.7709 21.918 17.77C20.7723 17.7656 19.8396 18.6903 19.834 19.836V19.836Z",
    stroke: "#F2F2F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 12.0662C11.9721 19.0002 18.6001 22.6602 21.9181 21.9022",
    stroke: "#F2F2F2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppShare);
export default __webpack_public_path__ + "static/media/whatsAppShare.3d43f90657b2b8e3d5b9e2ffaa8ee076.svg";
export { ForwardRef as ReactComponent };